<div
  class="blocking-overlay-backdrop"
  [class]="config.backdropClass"
  (click)="onBackdropClick()"
  (keyup)="onBackdropClick()"
  tabindex="0"
  role="dialog"
  aria-modal="true"
>
  <div
    class="blocking-overlay-content"
    [class]="config.overlayClass"
    (click)="stopPropagation($event)"
    (keyup)="stopPropagation($event)"
    tabindex="-1"
  >
    <!-- Dynamic Component -->
    @if (config.component) {
      <div #dynamicComponentContainer></div>
    }

    <!-- Template -->
    @if (config.template) {
      <ng-container [ngTemplateOutlet]="config.template" [ngTemplateOutletContext]="config.templateContext">
      </ng-container>
    }

    <!-- Default Content -->
    @if (!config.component && !config.template) {
      <div class="blocking-overlay-default">
        <!-- Icon -->
        @if (config.icon) {
          <div class="blocking-overlay-icon">
            <i [class]="config.icon"></i>
          </div>
        }

        <!-- Spinner -->
        @if (config.showSpinner) {
          <div class="blocking-overlay-spinner">
            <div class="spinner"></div>
          </div>
        }

        <!-- Message -->
        @if (config.message) {
          <div class="blocking-overlay-message">
            {{ config.message }}
          </div>
        }

        <!-- Actions -->
        @if (config.actions && config.actions.length > 0) {
          <div class="blocking-overlay-actions">
            @for (action of config.actions; track action.id) {
              <button
                [class]="'blocking-overlay-action ' + (action.class || '')"
                (click)="onActionClick(action.action)"
              >
                {{ action.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
